import { InvalidSubtitle, SkippedSubtitleTranslation } from "./s3-video-source-field.types";

const BytesPerMegabyte = 1024 * 1024;

const S3FolderErrorTranslationKeys: Record<string, string> = {
	elearningv2_several_videos_in_s_3_folder: "educationalOffer.s3VideoSeveralVideos",
	elearningv2_no_video_in_s_3_folder: "educationalOffer.s3VideoNotDirectlyInFolder",
	elearningv2_s_3_video_source_not_configured: "educationalOffer.s3VideoSourceNotConfigured",
	elearningv2_s_3_video_object_not_found: "educationalOffer.s3VideoVanished",
};

const S3FolderCheckFailedTranslationKey = "educationalOffer.s3VideoCheckFailed";

type ErrorWithResponse = Error & { res?: { errors?: { message?: string }[] } };

export const getSkippedSubtitleTranslation = ({
	language,
	invalidLine,
	keepsPublishedVersion,
}: InvalidSubtitle): SkippedSubtitleTranslation => {
	const outcome = keepsPublishedVersion ? "Kept" : "Skipped";

	return invalidLine
		? {
				translationKey: `educationalOffer.s3VideoSubtitle${outcome}AtLine`,
				options: { language, line: invalidLine },
		  }
		: {
				translationKey: `educationalOffer.s3VideoSubtitle${outcome}WithoutCues`,
				options: { language },
		  };
};

export const formatSizeInMegabytes = (sizeInBytes: number): string =>
	`${(sizeInBytes / BytesPerMegabyte).toFixed(1)} MB`;

export const getS3FolderErrorTranslationKey = (error: ErrorWithResponse): string =>
	(error.res?.errors ?? [])
		.map(
			(responseError) =>
				S3FolderErrorTranslationKeys[responseError.message?.toLowerCase() ?? ""],
		)
		.find((translationKey) => translationKey !== undefined) ??
	S3FolderCheckFailedTranslationKey;
